import React, { useState, useEffect, useRef } from 'react';
import "../../../assets/css/flightmonitor/flightmonitor.css";
import Header from "../../../Components/Header/Header";
import FtmDetails from './FtmDetails';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMagnifyingGlass, faPlaneDeparture, faArrowRight, faPlaneArrival, faPlane, faPaperclip, faCircleXmark, faCalendarDays, faPencil, faDownload, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';

import arrive from '../../../assets/images/flightmonitor/arrive.png';
import departure from '../../../assets/images/flightmonitor/departure.png';
import arrow from '../../../assets/images/flightmonitor/arrow.png';
import air from '../../../assets/images/flightmonitor/air.png';
import cb2 from '../../../assets/images/flightmonitor/cb2.png';
import cb1 from '../../../assets/images/flightmonitor/cb1.png';


const FlightMonitor = () => {

    const [ftmDetails, setFtmDetails] = useState(false);

    const handleDetails = () => {
        setFtmDetails(true)
    }

    const backToFtm = () => setFtmDetails(false)
    return (
        <div className="">
            <Header page_type='FTM' logo_url='/FlightMonitor' />
            <div className="page-body-wrapper position-relative">
                {ftmDetails ?
                    <>
                        {/* <Button className='backbtn' onClick={backToFtm}> <FontAwesomeIcon icon={faArrowLeft} /> Back</Button> */}
                        <div className='main-panel rounded'>
                            <Link to="#" onClick={backToFtm} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                            <FtmDetails />
                        </div>
                    </>
                    :
                    <>
                        <div className='main-panel rounded'>

                            <div className='main_top'>
                                <Row>
                                    <Col xs={12} lg={3} md={6}>
                                        <div className='flight-box blue-div'>
                                            <h3>Open Flights</h3>
                                            <h4>12</h4>
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={3} md={6}>
                                        <div className='flight-box org-div'>
                                            <h3>Flights in Progress</h3>
                                            <h4>03</h4>
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={3} md={6}>
                                        <div className='flight-box gren-div'>
                                            <h3>Flights Not Meeting SLA</h3>
                                            <h4>01</h4>
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={3} md={6}>
                                        <div className='flight-box red-div'>
                                            <h3>Flights Delayed</h3>
                                            <h4>01</h4>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='search-panel'>
                                <div className='search-left'>
                                    <Form.Control type="text" placeholder="Search Flights..." />
                                    <div className='search-icon'>
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </div>
                                    <div className='search-arrow'>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </div>
                                </div>
                                <div className='search-right-main'>
                                    <div className='search-right-l'>
                                        <span>
                                            <h3><b>Status</b></h3>
                                        </span>
                                        <Form>
                                            <div className="">
                                                <Form.Check
                                                    inline
                                                    label="Open"
                                                    name="group1"
                                                    type="checkbox"
                                                    id="inline-checkbox-1"
                                                />
                                                <Form.Check
                                                    inline
                                                    label="In progress"
                                                    name="group1"
                                                    type="checkbox"
                                                    id="inline-checkbox-2"
                                                />
                                                <Form.Check
                                                    inline
                                                    label="Poor"
                                                    name="group1"
                                                    type="checkbox"
                                                    id="inline-checkbox-3"
                                                />
                                                <Form.Check
                                                    inline
                                                    label="Kickout"
                                                    name="group1"
                                                    type="checkbox"
                                                    id="inline-checkbox-4"
                                                />
                                            </div>
                                        </Form>
                                    </div>
                                    <div className='search-right-r'>
                                        <Form>
                                            <>
                                                <div className="">
                                                    <Form.Check
                                                        inline
                                                        label="Active"
                                                        name="group1"
                                                        type="checkbox"
                                                        id="inline-checkbox-1"
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Archive"
                                                        name="group1"
                                                        type="checkbox"
                                                        id="inline-checkbox-2"
                                                    />
                                                </div>
                                            </>
                                        </Form>
                                    </div>
                                    <div className='frm-select'>
                                        <Form.Select aria-label="Default select example">
                                            <option>Actions</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </Form.Select>
                                    </div>
                                </div>
                            </div>
                            <div className='prgs-pnl-tbl'>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Form>
                                                    <div className="">
                                                        <Form.Check
                                                            name="group1"
                                                            type="checkbox"
                                                            id="inline-checkbox-6"
                                                        />
                                                    </div>
                                                </Form>
                                            </td>
                                            <td className='prs-tb'>
                                                {/* org-div /  */}
                                                <span className='prs-t org-div'>
                                                    <h4>In Progress</h4>
                                                </span>
                                            </td>
                                            <td className='arv-tb'>
                                                <div className='arrive'>
                                                    <span className='blue-cl'>
                                                        <h4>
                                                            XX3806
                                                        </h4>
                                                    </span>
                                                    <span style={{ display: 'flex', alignItems: 'center', }}>
                                                        <h4>
                                                            05:33
                                                        </h4>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlaneDeparture} />
                                                        </div>
                                                    </span>
                                                    <span className='red-cl'>
                                                        <h4>
                                                            05:40
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className=''>
                                                <div className='arrow-r'>
                                                    <div className='arrow_icon'>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='arv-tb'>
                                                <div className='arrive depart'>
                                                    <span style={{ display: 'flex', alignItems: 'center', }}>
                                                        <h4>
                                                            06:39
                                                        </h4>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlaneArrival} />
                                                        </div>
                                                    </span>
                                                    <span className='red-cl'>
                                                        <h4>
                                                            06:45
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='arvsyr-tb'>
                                                <div className='arrive syr'>
                                                    <span>
                                                        <h3>
                                                            Mar 12
                                                        </h3>
                                                        <h4>
                                                            SYR
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='ord-tb'>
                                                <div className='arrive'>
                                                    <span>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlane} />
                                                        </div>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='ord-tb'>
                                                <div className='arrive'>
                                                    <span>
                                                        <h4>ORD</h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='spt'>

                                                </div>
                                            </td>
                                            <td className='arnum-tb'>
                                                <div className='arrive cb1'>
                                                    <span className='arrive1'>
                                                        <img src={cb1} alt="My Image" />
                                                        <h4>125</h4>
                                                    </span>
                                                    <span>
                                                        <img src={cb2} alt="My Image" />
                                                        <h4>52</h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='rcf-tb'>
                                                <div className='rcf'>
                                                    <div>
                                                        <span className=''>
                                                            <h4>
                                                                RCF
                                                            </h4>
                                                        </span>
                                                        <span className='rcf-num'>
                                                            <h3>
                                                                87
                                                            </h3>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className=''>
                                                            <h4>
                                                                DIS
                                                            </h4>
                                                        </span>
                                                        <span className='rcf-num rcf-num-1'>
                                                            <h3>
                                                                3
                                                            </h3>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='sla sl-grn'>
                                                    <span>
                                                        <h4>
                                                            SLA
                                                        </h4>
                                                        <h4>
                                                            -02:45
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex justify-content-end'>
                                                    <div className='details-btn'>
                                                        <Button variant="primary" onClick={handleDetails}>
                                                            Details
                                                        </Button>
                                                    </div>
                                                    <div className='frm-select'>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Actions</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className='prgs-pnl-tbl'>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Form>
                                                    <div className="">
                                                        <Form.Check
                                                            name="group1"
                                                            type="checkbox"
                                                            id="inline-checkbox-6"
                                                        />
                                                    </div>
                                                </Form>
                                            </td>
                                            <td className='prs-tb'>
                                                {/* org-div /  gren-div /  red-div */}
                                                <span className='prs-t gren-div'>
                                                    <h4>Completed</h4>
                                                </span>
                                            </td>
                                            <td className='arv-tb'>
                                                <div className='arrive'>
                                                    <span className='blue-cl'>
                                                        <h4>
                                                            XX3806
                                                        </h4>
                                                    </span>
                                                    <span style={{ display: 'flex', alignItems: 'center', }}>
                                                        <h4>
                                                            05:33
                                                        </h4>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlaneDeparture} />
                                                        </div>
                                                    </span>
                                                    <span className='red-cl'>
                                                        <h4>
                                                            05:40
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className=''>
                                                <div className='arrow-r'>
                                                    <div className='arrow_icon'>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='arv-tb'>
                                                <div className='arrive depart'>
                                                    <span style={{ display: 'flex', alignItems: 'center', }}>
                                                        <h4>
                                                            06:39
                                                        </h4>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlaneArrival} />
                                                        </div>
                                                    </span>
                                                    <span className='red-cl'>
                                                        <h4>
                                                            06:45
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='arvsyr-tb'>
                                                <div className='arrive syr'>
                                                    <span>
                                                        <h3>
                                                            Mar 12
                                                        </h3>
                                                        <h4>
                                                            SYR
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='ord-tb'>
                                                <div className='arrive'>
                                                    <span>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlane} />
                                                        </div>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='ord-tb'>
                                                <div className='arrive'>
                                                    <span>
                                                        <h4>ORD</h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='spt'>

                                                </div>
                                            </td>
                                            <td className='arnum-tb'>
                                                <div className='arrive cb1'>
                                                    <span className='arrive1'>
                                                        <img src={cb1} alt="My Image" />
                                                        <h4>125</h4>
                                                    </span>
                                                    <span>
                                                        <img src={cb2} alt="My Image" />
                                                        <h4>52</h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='rcf-tb'>
                                                <div className='rcf'>
                                                    <div>
                                                        <span className=''>
                                                            <h4>
                                                                RCF
                                                            </h4>
                                                        </span>
                                                        <span className='rcf-num rcf-rd'>
                                                            <h3>
                                                                144
                                                            </h3>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className=''>
                                                            <h4>
                                                                DIS
                                                            </h4>
                                                        </span>
                                                        <span className='rcf-num rcf-num-1'>
                                                            <h3>
                                                                3
                                                            </h3>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                {/* sl-org / sl-grn / sl-red */}
                                                <div className='sla sl-org'>
                                                    <span>
                                                        <h4>
                                                            SLA
                                                        </h4>
                                                        <h4>
                                                            -02:45
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex justify-content-end'>
                                                    <div className='details-btn'>
                                                        <Button variant="primary" onClick={handleDetails}>
                                                            Details
                                                        </Button>
                                                    </div>
                                                    <div className='frm-select'>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Actions</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>
                                                    </div>
                                                </div>
                                            </td>

                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className='prgs-pnl-tbl'>
                                <Table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Form>
                                                    <div className="">
                                                        <Form.Check
                                                            name="group1"
                                                            type="checkbox"
                                                            id="inline-checkbox-6"
                                                        />
                                                    </div>
                                                </Form>
                                            </td>
                                            <td className='prs-tb'>
                                                {/* org-div /  */}
                                                <span className='prs-t red-div'>
                                                    <h4>Delayed</h4>
                                                </span>
                                            </td>
                                            <td className='arv-tb'>
                                                <div className='arrive'>
                                                    <span className='blue-cl'>
                                                        <h4>
                                                            XX3806
                                                        </h4>
                                                    </span>
                                                    <span style={{ display: 'flex', alignItems: 'center', }}>
                                                        <h4>
                                                            05:33
                                                        </h4>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlaneDeparture} />
                                                        </div>
                                                    </span>
                                                    <span className='red-cl'>
                                                        <h4>
                                                            05:40
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className=''>
                                                <div className='arrow-r'>
                                                    <div className='arrow_icon'>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='arv-tb'>
                                                <div className='arrive depart'>
                                                    <span style={{ display: 'flex', alignItems: 'center', }}>
                                                        <h4>
                                                            06:39
                                                        </h4>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlaneArrival} />
                                                        </div>
                                                    </span>
                                                    <span className='red-cl'>
                                                        <h4>
                                                            06:45
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='arvsyr-tb'>
                                                <div className='arrive syr'>
                                                    <span>
                                                        <h3>
                                                            Mar 12
                                                        </h3>
                                                        <h4>
                                                            SYR
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='ord-tb'>
                                                <div className='arrive'>
                                                    <span>
                                                        <div className='fl_dep_icon'>
                                                            <FontAwesomeIcon icon={faPlane} />
                                                        </div>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='ord-tb'>
                                                <div className='arrive'>
                                                    <span>
                                                        <h4>ORD</h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='spt'>

                                                </div>
                                            </td>
                                            <td className='arnum-tb'>
                                                <div className='arrive cb1'>
                                                    <span className='arrive1'>
                                                        <img src={cb1} alt="My Image" />
                                                        <h4>125</h4>
                                                    </span>
                                                    <span>
                                                        <img src={cb2} alt="My Image" />
                                                        <h4>52</h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td className='rcf-tb'>
                                                <div className='rcf'>
                                                    <div>
                                                        <span className=''>
                                                            <h4>
                                                                RCF
                                                            </h4>
                                                        </span>
                                                        <span className='rcf-num'>
                                                            <h3>
                                                                87
                                                            </h3>
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <span className=''>
                                                            <h4>
                                                                DIS
                                                            </h4>
                                                        </span>
                                                        <span className='rcf-num rcf-num-1'>
                                                            <h3>
                                                                3
                                                            </h3>
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='sla sl-red'>
                                                    <span>
                                                        <h4>
                                                            SLA
                                                        </h4>
                                                        <h4>
                                                            -02:45
                                                        </h4>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='d-flex justify-content-end'>
                                                    <div className='details-btn'>
                                                        <Button variant="primary" onClick={handleDetails}>
                                                            Details
                                                        </Button>
                                                    </div>
                                                    <div className='frm-select'>
                                                        <Form.Select aria-label="Default select example">
                                                            <option>Actions</option>
                                                            <option value="1">One</option>
                                                            <option value="2">Two</option>
                                                            <option value="3">Three</option>
                                                        </Form.Select>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

export default FlightMonitor;
